<div class="sidebar" [class.collapsed]="!isExpanded">
  <!-- Logo y flecha juntos cuando expandido -->
  @if (isExpanded) {
  <div class="sidebar__logo-wrapper" style="position: relative">
    <div class="sidebar__logo">
      <img
        [src]="
          isDarkTheme
            ? 'assets/images/excuela-logo-white.svg'
            : 'assets/images/excuela-logo.svg'
        "
        alt="Excuela Logo"
      />
    </div>
    <div
      class="sidebar__toggle sidebar__toggle--expanded"
      (click)="toggleSidebar()"
      [pTooltip]="'layout.sidebar.collapseMenu' | translate"
      tooltipPosition="right"
    >
      <i class="fas fa-angle-double-left"></i>
    </div>
  </div>
  }
  <!-- Flecha sola cuando colapsado -->
  @if (!isExpanded) {
  <div
    class="sidebar__toggle"
    (click)="toggleSidebar()"
    [pTooltip]="'layout.sidebar.expandMenu' | translate"
    tooltipPosition="right"
  >
    <i class="fas fa-angle-double-right"></i>
  </div>
  }
  <!-- Logo solo cuando colapsado -->
  @if (!isExpanded) {
  <div class="sidebar__logo">
    @if (!isDarkTheme) {
    <img src="assets/images/excuela-x-blue.svg" alt="Excuela Logo Azul" />
    } @else {
    <img src="assets/images/excuela-x.svg" alt="Excuela Logo" />
    }
  </div>
  }

  <!-- Navigation Menu -->
  <nav class="sidebar__nav">
    @if (loadingComponent) { @for (skeletonItem of createNumberArray(6); track
    skeletonItem; let i = $index) {
    <div class="sidebar__nav-item">
      <div class="sidebar__item">
        <p-skeleton width="20px" height="20px" borderRadius="4px"> </p-skeleton>
        @if (isExpanded) {
        <p-skeleton width="120px" height="16px" borderRadius="4px">
        </p-skeleton>
        } @if (i % 3 === 0 && isExpanded) {
        <p-skeleton width="12px" height="12px" borderRadius="4px"> </p-skeleton>
        }
      </div>
    </div>
    } } @else { @for (item of menuItems; track item.id; let i = $index) {
    <div
      class="sidebar__nav-item"
      [class.expanded]="item.hasSubMenu && item.expanded"
    >
      <a
        [routerLink]="item.hasSubMenu ? null : item.route"
        (click)="item.hasSubMenu && toggleSubMenu(item)"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        class="sidebar__item"
        [class.has-submenu]="item.hasSubMenu"
        [class.expanded]="item.expanded"
        [pTooltip]="!isExpanded ? (item.label | translate) : ''"
        tooltipPosition="right"
      >
        <i [class]="item.icon"></i>
        @if (isExpanded) {
        <span
          class="truncate"
          [appTooltipIfTruncated]="item.label | translate"
        >{{ item.label | translate }}</span>
        } @if (item.hasSubMenu && isExpanded) {
        <i
          class="fas"
          [ngClass]="item.expanded ? 'fa-chevron-down' : 'fa-chevron-right'"
          style="font-size: 0.6rem"
        ></i>
        }
      </a>
      @if (item.hasSubMenu && item.expanded) {
      <div class="sidebar__submenu" [@submenuAnimation]>
        @for (subItem of item.subItems; track subItem.id) {
        <a
          [routerLink]="subItem.route"
          routerLinkActive="active"
          class="sidebar__submenu-item"
          [pTooltip]="!isExpanded ? (subItem.label | translate) : ''"
          tooltipPosition="right"
        >
          <i [class]="subItem.icon"></i>
          @if (isExpanded) {
          <span class="ml-2 truncate" [appTooltipIfTruncated]="subItem.label | translate">{{ subItem.label | translate }}</span>
          }
        </a>
        }
      </div>
      }
    </div>
    } }
  </nav>

  <!-- Bottom Section -->
  <div class="sidebar__bottom">
    <!-- Logout Button -->
    <div class="logout-section">
      <a
        (click)="!loading && logout()"
        class="logout-button"
        [class.disabled]="loading"
        [pTooltip]="
          !isExpanded ? (loading ? ('layout.sidebar.closingSession' | translate) : ('layout.sidebar.closeSession' | translate)) : ''
        "
        tooltipPosition="right"
      >
        <i
          class="fas"
          [class.fa-sign-out-alt]="!loading"
          [class.fa-spinner]="loading"
          [class.fa-spin]="loading"
        ></i>
        <span class="logout-text" [class.visible]="isExpanded">
          @if (loading) { {{ 'layout.sidebar.closingSession' | translate }} } @else { {{ 'layout.sidebar.closeSession' | translate }} }
        </span>
      </a>
    </div>

    <!-- User Profile -->
    <div
      class="user-profile"
      [pTooltip]="!isExpanded ? userStateService.currentUser()?.fullname : ''"
      tooltipPosition="right"
    >
      <div class="user-profile__avatar">
        <img
          src="assets/images/user-profile.svg"
          alt="User Profile"
          width="32"
          height="32"
        />
      </div>
      <div class="user-profile__info" [class.visible]="isExpanded">
        <div class="user-profile__name">
          {{ userStateService.currentUser()?.fullname }}
        </div>
        <div class="user-profile__link" (click)="menu.toggle($event)">
          {{ 'layout.sidebar.viewMyAccount' | translate }}
        </div>
        <p-menu #menu [model]="accountOptions" [popup]="true" />
      </div>
    </div>

    <div class="sidebar__version">v{{ appVersion }}</div>
  </div>
</div>
